import { RoutesNavigationDefaults } from 'embeddables/src/defaults'
import { RouteDefinition, Routes, TableRouteConfig } from 'embeddables/src/Route'
import mergeWith from 'lodash/mergeWith'
import { Banknote, Coins, HandCoins, LucideProps, Store, SwitchCamera } from 'lucide-vue-next'
import { FunctionalComponent } from 'vue'

export const RoutesDefaults: Record<
  Routes,
  RouteDefinition & {
    icon: FunctionalComponent<LucideProps, {}, any, {}>
    hideNavigation?: boolean
  }
> = mergeWith(
  {},
  {
    [Routes.ACCOUNTS]: {
      displayText: 'Kontoer',
      icon: Store,
    },
    [Routes.CREATE_ACCOUNT]: {
      displayText: 'Opprett konto',
      icon: Store,
    },
    [Routes.PAYMENTS]: {
      displayText: 'Betalinger',
      icon: Banknote,
    },
    [Routes.PAYOUTS]: {
      displayText: 'Utbetalinger',
      icon: HandCoins,
    },
    [Routes.INVOICES]: {
      displayText: 'Delbetalinger',
      icon: Coins,
    },
    [Routes.INVOICES_REFUND]: {
      displayText: 'Juster faktura',
      icon: SwitchCamera,
    },
    [Routes.PAYMENTS_REFUND]: {
      displayText: 'Refunder betaling',
      icon: SwitchCamera,
    },
    [Routes.REFUND_REQUESTS]: {
      displayText: 'Refusjonsforespørsler',
      icon: SwitchCamera,
    },
    [Routes.EXTERNAL_ACCOUNT_ONBOARDING]: {
      displayText: 'Ekstern konto onboarding',
      icon: SwitchCamera,
    },
  },
  RoutesNavigationDefaults
)

export const getDefaultTableRoutesOptions = (): Partial<TableRouteConfig<any>['table']> => ({
  useSearch: true,
  staticSearch: false,
})

export const getDefaultRouteSettings = (route: Routes): Partial<RouteDefinition<any>> => {
  return {
    options: {
      table: getDefaultTableRoutesOptions(),
    },
    routeName: route, //`${route}-${defaultId++}`,
    displayText: RoutesDefaults[route].displayText,
  }
}

export const fillRouteWithDefaults = (route: Partial<RouteDefinition>): RouteDefinition => {
  return {
    ...getDefaultRouteSettings(route.path!),
    ...route,
    options: {
      ...getDefaultTableRoutesOptions(),
      ...route.options,
    },
  } as RouteDefinition
}
